(function () {
  if (typeof window === 'undefined') return;
  if (window.__cordaroysSiblingLockInitialized) return;
  window.__cordaroysSiblingLockInitialized = true;

  var colorMapCache = new WeakMap();
  var pickerListenerCache = new WeakMap();

  var normalize = function (value) {
    return (value || '').toString().trim().toLowerCase();
  };

  var parseColorMap = function (link) {
    if (!link) return null;
    if (colorMapCache.has(link)) {
      return colorMapCache.get(link);
    }

    var attr = link.getAttribute('data-color-map');
    if (!attr) {
      colorMapCache.set(link, null);
      return null;
    }

    try {
      var map = JSON.parse(attr);
      colorMapCache.set(link, map && typeof map === 'object' ? map : null);
    } catch (error) {
      colorMapCache.set(link, null);
    }

    return colorMapCache.get(link);
  };

  var getVariantColor = function (variant, index) {
    if (!variant || index < 0) return '';

    var direct = variant['option' + (index + 1)];
    if (direct) return direct;

    if (Array.isArray(variant.options) && variant.options.length > index) {
      return variant.options[index];
    }

    return '';
  };

  var updateLinksForColor = function (group, normalizedColor) {
    if (!group) return;

    if (group.getAttribute('data-last-color') === normalizedColor) {
      return;
    }

    var links = group.querySelectorAll('[data-color-map]');
    links.forEach(function (link) {
      var baseUrl = link.getAttribute('data-base-url');
      if (!baseUrl) return;

      var href = baseUrl;
      var map = parseColorMap(link);

      if (map && Object.prototype.hasOwnProperty.call(map, normalizedColor)) {
        var variantId = map[normalizedColor];
        if (variantId) {
          href = baseUrl + '?variant=' + variantId;
        }
      }

      if (link.getAttribute('href') !== href) {
        link.setAttribute('href', href);
      }
    });

    group.setAttribute('data-last-color', normalizedColor);
  };

  var normalizeId = function (value) {
    if (!value) return '';
    var stringValue = value.toString();
    var match = stringValue.match(/(\d+)(?:[^\d]*)$/);
    return match ? match[1] : stringValue;
  };

  var processVariantUpdate = function (variant, productId) {
    if (!variant) return;

    var groups = document.querySelectorAll('[data-sibling-picker][data-color-option-index]');

    groups.forEach(function (group) {
      var groupProductId = group.getAttribute('data-product-id');
      if (groupProductId && productId) {
        if (normalizeId(groupProductId) !== normalizeId(productId)) {
          return;
        }
      }

      var index = Number(group.getAttribute('data-color-option-index'));
      if (isNaN(index) || index < 0) return;

      var colorValue = getVariantColor(variant, index);
      var normalizedColor = normalize(colorValue);
      if (!normalizedColor) return;

      updateLinksForColor(group, normalizedColor);
    });
  };

  var isColorMatch = function (target, colorName) {
    if (!target || !colorName) return false;

    var normalizedColorName = colorName.toLowerCase();
    var nameAttr = (target.name || '').toString().toLowerCase();

    if (nameAttr.includes(normalizedColorName)) {
      return true;
    }

    if (nameAttr.indexOf('options[') === 0 && nameAttr.includes('[' + normalizedColorName + ']')) {
      return true;
    }

    var fieldset = target.closest('.variant-option');
    if (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (legend && normalize(legend.textContent) === normalizedColorName) {
        return true;
      }
    }

    return false;
  };

  var attachColorChangeListener = function (group) {
    if (!group) return;

    var productId = group.getAttribute('data-product-id');
    if (!productId) return;

    var picker = document.querySelector('variant-picker[data-product-id="' + productId + '"]');
    if (!picker || pickerListenerCache.has(picker)) return;

    var colorOptionName = group.getAttribute('data-color-option-name');
    if (!colorOptionName) return;

    var normalizedColorName = colorOptionName.toLowerCase();

    var handler = function (event) {
      var target = event && event.target;
      if (!target) return;

      if (!isColorMatch(target, normalizedColorName)) {
        return;
      }

      var value = target.value;
      if (!value && target.options && target.selectedIndex >= 0) {
        value = target.options[target.selectedIndex].value;
      }

      var normalized = normalize(value);
      if (!normalized) return;

      updateLinksForColor(group, normalized);
    };

    picker.addEventListener('change', handler);
    pickerListenerCache.set(picker, handler);
  };

  var initializeGroups = function (selector) {
    var groups = document.querySelectorAll(selector || '[data-sibling-picker][data-color-option-index]');

    groups.forEach(function (group) {
      var index = Number(group.getAttribute('data-color-option-index'));
      if (isNaN(index) || index < 0) return;

      var initial = normalize(group.getAttribute('data-initial-color'));
      if (initial) {
        updateLinksForColor(group, initial);
      }

      attachColorChangeListener(group);
    });
  };

  var init = function () {
    initializeGroups();

    document.addEventListener('variant:update', function (event) {
      if (!event || !event.detail) return;
      var variant = event.detail.resource;
      var productId = event.detail.data && event.detail.data.productId;
      processVariantUpdate(variant, productId);
    });

    document.addEventListener('cordaroys:pdp:swapped', function (event) {
      var detail = event && event.detail;
      var blockId = detail && detail.blockId;
      var selector = blockId
        ? '[data-sibling-picker][data-color-option-index][data-block-id="' + blockId + '"]'
        : '[data-sibling-picker][data-color-option-index]';

      var schedule = function () {
        initializeGroups(selector);
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(schedule, { timeout: 300 });
      } else {
        setTimeout(schedule, 1);
      }
    });
  };

  var runInit = function () {
    init();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit, { once: true });
  } else {
    runInit();
  }
})();
